import { render, staticRenderFns } from "./import-substitution-card-closed.vue?vue&type=template&id=1261bc52&scoped=true&"
import script from "./import-substitution-card-closed.vue?vue&type=script&lang=js&"
export * from "./import-substitution-card-closed.vue?vue&type=script&lang=js&"
import style0 from "./import-substitution-card-closed.vue?vue&type=style&index=0&id=1261bc52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1261bc52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1261bc52')) {
      api.createRecord('1261bc52', component.options)
    } else {
      api.reload('1261bc52', component.options)
    }
    module.hot.accept("./import-substitution-card-closed.vue?vue&type=template&id=1261bc52&scoped=true&", function () {
      api.rerender('1261bc52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/import-substitution/import-substitution-card-closed.vue"
export default component.exports